import { useEffect, useState } from "react";
import { connect } from 'react-redux';

// icn
import { convertBytesUnit, formatPriceUSD, printFormattedBytes, TIMESTAMP_FORMAT_TODATE } from "helpers/common";
import { Link } from "react-router-dom";
import * as actions from "store/actions";
import { getBillingPortalURL, getStorageInfo } from "store/services/documentStorgeService";
import { upgradeDocumentStorage } from "Routes/paths";
import { Col, Row } from "react-bootstrap";
import StorageChart from "./Components/StorageChart";
import ErrorFallbackUI from "components/shared/ErrorFallbackUI";
import FileManager from "pages/SideTabs/DocumentStorage/FileManager/Index";
//imported

const DocumentStorage = ({ dispatch }) => {
  const [storageDetails, setStorageDetails] = useState(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getStorageInfoData();
  }, []);

  const getStorageInfoData = async () => {
    try {
      setLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let response = await getStorageInfo();
      if (response?.success) {
        setStorageDetails(response?.body);
      }
      setLoading(false);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      setLoading(false);
      dispatch(actions.persist_store({ loader: false }));
      console.error("Error fetching storage details", err);
    }
  };

  const openBillingPortal = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let response = await getBillingPortalURL();
      if (response?.body?.url) {
        window.location.href = response?.body?.url;
      }
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.error("Error fetching storage details", err);
    }
  };

  return (
    <section className="container-fluid my-2">
      <div className="commonContent py-2">
        <div className="top">
          <h3 className="m-0 fw-bold">Storage Information</h3>
        </div>
        <div className="subscription-info py-3">
          {isLoading ? (
            <div className="text-center">
              <p>Loading...</p>
            </div>
          ) : storageDetails ? (
            <Row className="">
              <Col lg={6}>
                <div className="">
                  <StorageChart
                    storageDetails={storageDetails}
                  />
                  <ul className="asterisk-list">
                    <li>
                      Document Storage includes all PDFs, images, Word documents, and Excel files uploaded by practitioners and clients in the Documents tab. It does not include any client-submitted forms such as the NAQ, Food & Mood Journal, etc.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={6}>
                <div className="commonCardBox PricingCard p-3 text-white" style={{ background: "var(--bs-button)" }}>
                  <div className="">
                    {(storageDetails?.plan_status === "active" || storageDetails?.plan_id) ? (
                      <>
                        <div className="d-flex justify-content-between align-items-baseline mb-2">
                          <h4 className="fw-bold text-white">
                            {storageDetails?.plan_name}
                            <br />
                            {storageDetails?.plan_status === "canceled" && <span className="fs-6 fw-normal">(Canceled)</span>}
                          </h4>
                          <p className="m-0 mb-1 me-5">
                            <strong>{formatPriceUSD(storageDetails?.price_paid)}</strong> / {storageDetails?.duration} Days
                          </p>
                        </div>
                        <div className="my-2">
                          <p className="m-0">
                            <span className="fw-bold">
                              {storageDetails?.total_storage_available
                                ? printFormattedBytes(convertBytesUnit(storageDetails?.total_storage_available || 0, "mb", "bytes"))
                                : "0.00 MB"
                              }
                            </span>{" "}
                            Total Storage Size
                          </p>
                        </div>
                        {storageDetails?.plan_status === "active" && (
                          <>
                            {(storageDetails?.cancellation_status !== "canceled" && storageDetails?.cancel_at) ? (
                              <div className="my-2">
                                <p className="m-0">Cancels at {TIMESTAMP_FORMAT_TODATE(storageDetails?.cancel_at)}</p>
                              </div>
                            ) : !storageDetails?.cancel_at && (
                              <div className="my-2">
                                <p className="m-0">Next payment at {TIMESTAMP_FORMAT_TODATE(storageDetails?.current_period_end)}</p>
                              </div>
                            )}
                          </>
                        )}
                        <div className="mt-4">
                          {storageDetails?.plan_status === "active" && (
                            <p className="m-0"><Link className="text-white text-decoration-underline fw-bold" onClick={openBillingPortal}>Manage Subscription</Link></p>
                          )}
                          <p className="m-0">
                            <Link className="text-white text-decoration-underline fw-bold" to={upgradeDocumentStorage}>
                              {storageDetails?.plan_status === "canceled" ? "Buy More Storage" : "Upgrade Plan"}
                            </Link>
                          </p>
                        </div>
                      </>
                    ) : (
                      <div className="text-white">
                        <div className="d-flex justify-content-between align-items-baseline mb-2">
                          <h4 className="fw-bold text-white">
                            Free Plan
                            <br />
                          </h4>
                        </div>
                        <div className="my-2">
                          <p className="m-0">
                            <span className="fw-bold">
                              {storageDetails?.total_storage_available
                                ? printFormattedBytes(convertBytesUnit(storageDetails?.total_storage_available || 0, "mb", "bytes"))
                                : "0.00 MB"
                              }
                            </span>{" "}
                            Total Storage Size
                          </p>
                        </div>
                        <p className="">You don't have any active plan yet.</p>
                        <p className="m-0"><Link className="text-white text-decoration-underline fw-bold" to={upgradeDocumentStorage}>Buy More Storage</Link></p>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <ErrorFallbackUI />
          )}
        </div>
      </div>
      <div className="commonContent py-2">
        <h3 className="m-0 fw-bold">Client Storage Usage Overview</h3>
      </div>
      <div className="py-3 mb-4">
        <FileManager />
      </div>
    </section>
  );
};


const mapStateToPros = (state) => {
  return {}
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(DocumentStorage);
